// import React from "react";
// import styled from "styled-components";
// const VideoLoader = ({ thumbnail }) => {
//   return (
//     <Load thumbnail={thumbnail}>
//       <BlurContainer>
//         <Spinner />
//       </BlurContainer>
//     </Load>
//   );
// };
// export default VideoLoader;
// const Spinner = styled.div`
//   border: 16px solid #f3f3f3;
//   border-radius: 50%;
//   border-top: 16px solid #f02a4c;
//   width: 20%;
//   aspect-ratio: 1;
//   margin: auto;
//   -webkit-animation: spin 2s linear infinite; /* Safari */
//   animation: spin 2s linear infinite;
//   @keyframes spin {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }
// `;
// const Load = styled.div`
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   z-index: 3;
//   background-image: url(${({ thumbnail }) => thumbnail});
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: center;
//   border-radius: 15px;
// `;

// const BlurContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   backdrop-filter: blur(1rem);
//   width: 100%;
//   height: 100%;
//   border-radius: 15px;
// `;

import React from "react";
import { ThreeDots } from "react-loader-spinner";
import styled from "styled-components";

const VideoLoader = ({ thumbnail }) => (
  <LoaderContainer
    style={
      thumbnail && {
        backgroundImage: `url(${thumbnail})`,
      }
    }
  >
    <ThreeDots
      height="50"
      width="50"
      radius="9"
      color="#f02a4c"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClassName=""
      visible={true}
    />
  </LoaderContainer>
);

const LoaderContainer = styled.div`
  position: absolute;
  display: flex;
  background-size: cover;
  object-fit: contain !important;
  align-items: center;
  justify-content: center;
  background-color: black;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  z-index: 3;
`;

export default VideoLoader;
